module.exports = __webpack_public_path__ + "static/media/plus.3b7b2fae.svg";